import { render } from "./itemDefault.vue?vue&type=template&id=2844a487&scoped=true"
import script from "./itemDefault.vue?vue&type=script&lang=js"
export * from "./itemDefault.vue?vue&type=script&lang=js"

import "./itemDefault.vue?vue&type=style&index=0&id=2844a487&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2844a487"]])

export default __exports__